import { render } from "./HintQuestionIcon.vue?vue&type=template&id=5f30b073"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__